import {
    calculateCommission,
    calculateIof,
    calculatePmt,
    calculateCet,
    adjustForGracePeriod
} from '..';

export interface ISimulation {
    pmt: number;
    monthlyCet: number;
    annualCet: number;
    interestAmount: number;
}

export interface ISimulationParams {
    amount: number;
    tenure: number;
    interestRate: number;
    loanDate: Date;
    dueDate: Date;
    isSimplesNacional: boolean;
    commissionRate?: number;
    commissionDiscount?: number;
}

export const getSimulation = (request: ISimulationParams): ISimulation => {
    const {
        amount,
        tenure,
        loanDate,
        dueDate,
        interestRate,
        isSimplesNacional,
        commissionRate,
        commissionDiscount
    } = request;

    const commission = calculateCommission({ 
        amount,
        tenure,
        rate: commissionRate,
        discount: commissionDiscount
    });

    const iof = calculateIof({
        amount: amount + commission,
        isSimplesNacional,
        tenure,
        dueDate,
        loanDate
    });

    const future = adjustForGracePeriod({
        amount: amount + commission,
        dueDate,
        loanDate,
        interestRate,
        iof
    });

    const pmt = calculatePmt({ amount: future, interestRate, tenure });
    const cet = calculateCet({ amount, dueDate, loanDate, pmt, tenure });
    const interestAmount = pmt * tenure - amount;

    return {
        pmt,
        interestAmount,
        monthlyCet: cet.monthlyRate,
        annualCet: cet.annualyRate
    };
};
